import SubscriptionPlans from "./subscription-plans.container";

export default SubscriptionPlans;
